export default __webpack_public_path__ + "static/media/OQF landscape.6e201620.jpg";